export function PageShell({ children, className = "" }) {
  return (
    <div className={`relative min-h-screen ${className}`}>
      <div className="relative z-10">{children}</div>
    </div>
  );
}

export function Section({ children, className = "", innerClassName = "", ...rest }) {
  return (
    <section className={`relative z-10 ${className}`} {...rest}>
      <div className={`max-w-[1400px] mx-auto px-6 ${innerClassName}`}>{children}</div>
    </section>
  );
}

export function Overline({ children }) {
  return <div className="overline text-primary">{children}</div>;
}

export function MetricCard({ label, value, delta, testId, icon: Icon }) {
  return (
    <div className="glass rounded-2xl p-6 hover-lift" data-testid={testId}>
      <div className="flex items-start justify-between">
        <div className="overline text-muted-foreground">{label}</div>
        {Icon && <Icon size={16} className="text-primary" />}
      </div>
      <div className="stat-value text-4xl mt-3">{value}</div>
      {delta && <div className="text-xs text-muted-foreground mt-2">{delta}</div>}
    </div>
  );
}
